// extracted by mini-css-extract-plugin
module.exports = {"glossary":"index_glossary__U22D2","glossaryContent":"index_glossaryContent__KepJl"};